export default "__VITE_ASSET__Dj41HzAv__"